module.exports = __webpack_public_path__ + "img/求职者.5698b122.png";